import React from "react";
import TrialBalance from "../../Reports/TrialBalance/TrialBalance";

export default function TrialBalanceReport() {
  return <TrialBalance />;
}
